import axios from "axios";
import API from "../helpers/api";
import {  getOthersMI,getEuMI } from "./MDDetailAPI";
export const updateMDInfo = (data) => {
  let url = `${API.MDUpdateAPI}`;
  return dispatch => {
    axios.put(url, data)
      .then((response) => {
        dispatch({
          type: "putMaterialDeclarationSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "MDDeleteFailure",
          error: "ERROR"
        })
      })
  }
}
export const deleteMIInfo = (data,id) => {
  let url = `${API.MIUpdateAPI}`;
  return dispatch => {
    axios.put(url, data)
      .then((response) => {
        dispatch(getOthersMI(id));
        dispatch({
          type: "deleteMaterialDeclarationSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "MDDeleteFailure",
          error: "ERROR"
        })
      })
  }
}
export const deleteEUInfo = (data,id) => {
  let url = `${API.MIUpdateAPI}`;
  return dispatch => {
    axios.put(url, data)
      .then((response) => {
        dispatch(getOthersMI(id));
        dispatch({
          type: "deleteMaterialDeclarationSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "MDDeleteFailure",
          error: "ERROR"
        })
      })
  }
}
export const updateMIInfo = (data) => {
  let url = `${API.MIUpdateAPI}`;
  return dispatch => {
    axios.put(url, data)
      .then((response) => {
        dispatch({type:"ResetMI",data:true})
        dispatch({
          type: "putMaterialDeclarationSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "MDDeleteFailure",
          error: "ERROR"
        })
      })
  }
}
export const updateRDInfo = (data) => {
  let url = `${API.RDUpdateAPI}`;
  return dispatch => {
    axios.put(url, data)
      .then((response) => {
        dispatch({
          type: "putMaterialDeclarationSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "MDDeleteFailure",
          error: "ERROR"
        })
      })
  }
}
export const updateMDRemarks = (data) => {
  let url = `${API.RemarkPostAPI}`;
  return dispatch => {
    axios.put(url, data)
      .then((response) => {
        dispatch({
          type: "putMDRemarksSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "MDRemarksDeleteFailure",
          error: "ERROR"
        })
      })
  }
}